module.exports = __webpack_public_path__ + "static/media/progman_8.1673dbed.ico";